import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Shield, Search } from 'lucide-react';

export default function PublicVerify() {
  const [verificationCode, setVerificationCode] = useState('');
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const handleVerify = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');

    const code = verificationCode.trim();

    if (!code) {
      setError('Vennligst skriv inn en verifiseringskode');
      return;
    }

    // Navigate to the verification page
    navigate(`/verify/${code}`);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-kf-primary via-kf-secondary to-kf-primary flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Logo/Header */}
        <div className="text-center mb-8">
          <div className="inline-flex items-center justify-center w-20 h-20 bg-white rounded-full mb-4 shadow-lg">
            <Shield className="text-kf-primary" size={48} />
          </div>
          <h1 className="text-3xl font-bold text-white mb-2">
            Kompetanseattest
          </h1>
          <p className="text-kf-light text-lg">
            Verifiser studieplan
          </p>
        </div>

        {/* Verification Card */}
        <div className="bg-white rounded-lg shadow-xl p-8">
          <h2 className="text-xl font-semibold text-gray-900 mb-2">
            Verifiser godkjent studieplan
          </h2>
          <p className="text-sm text-gray-600 mb-6">
            Skriv inn verifiseringskoden fra studieplanen eller QR-koden for å se detaljene.
          </p>

          <form onSubmit={handleVerify} className="space-y-4">
            <div>
              <label htmlFor="code" className="block text-sm font-medium text-gray-700 mb-2">
                Verifiseringskode
              </label>
              <input
                id="code"
                type="text"
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-kf-primary focus:border-transparent transition-all"
                placeholder="Skriv inn verifiseringskode..."
                value={verificationCode}
                onChange={(e) => setVerificationCode(e.target.value)}
                autoFocus
              />
            </div>

            {error && (
              <div className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm">
                {error}
              </div>
            )}

            <button
              type="submit"
              className="w-full bg-kf-primary hover:bg-kf-dark text-white font-semibold py-3 px-4 rounded-lg transition-colors flex items-center justify-center gap-2"
            >
              <Search size={20} />
              Verifiser studieplan
            </button>
          </form>

          <div className="mt-6 pt-6 border-t border-gray-200">
            <p className="text-xs text-gray-500 text-center">
              Verifiseringskoden finner du på den offentlige studieplanen eller via QR-koden på kompetanseattesten.
            </p>
          </div>
        </div>

        {/* Footer */}
        <div className="mt-8 text-center text-white text-sm">
          <p>
            Kompetanseforbundet © {new Date().getFullYear()}
          </p>
          <p className="mt-1 text-kf-light">
            Kvalitetssikring av studieplaner
          </p>
        </div>
      </div>
    </div>
  );
}
